import FunnelSteps from './FunnelSteps';
export default FunnelSteps;